/** Client-side token wallet until a real platform wallet API exists. */

export const GUEST_TOKEN_DEFAULT = 10_000;
export const USER_TOKEN_DEFAULT = 20_000;

const GUEST_KEY = "nevisign.reader.tokens.guest";
const USER_PREFIX = "nevisign.reader.tokens.user.";

function readNumber(key: string, fallback: number): number {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    const n = Number(raw);
    return Number.isFinite(n) && n >= 0 ? Math.floor(n) : fallback;
  } catch {
    return fallback;
  }
}

function writeNumber(key: string, value: number): void {
  try {
    localStorage.setItem(key, String(Math.max(0, Math.floor(value))));
  } catch {
    /* ignore quota */
  }
}

export function getGuestTokenBalance(): number {
  return readNumber(GUEST_KEY, GUEST_TOKEN_DEFAULT);
}

export function getUserTokenBalance(userId: string): number {
  return readNumber(`${USER_PREFIX}${userId}`, USER_TOKEN_DEFAULT);
}

export function getDisplayTokenBalance(opts: {
  isAuthenticated: boolean;
  userId?: string | null;
}): number {
  if (opts.isAuthenticated && opts.userId) {
    return getUserTokenBalance(opts.userId);
  }
  return getGuestTokenBalance();
}

export function setTokenBalance(
  opts: { isAuthenticated: boolean; userId?: string | null },
  value: number,
): void {
  if (opts.isAuthenticated && opts.userId) {
    writeNumber(`${USER_PREFIX}${opts.userId}`, value);
  } else {
    writeNumber(GUEST_KEY, value);
  }
}

/** Top-up placeholder until billing API exists. */
export function addTokenCredit(
  opts: { isAuthenticated: boolean; userId?: string | null },
  amount: number,
): number {
  const next = getDisplayTokenBalance(opts) + Math.max(0, Math.floor(amount));
  setTokenBalance(opts, next);
  return next;
}

export function formatTokenFa(n: number): string {
  return n.toLocaleString("fa-IR");
}
